import { Schema } from '@blade/std-lib'

// https://oembed.com/ subset used by https://www.tiktok.com/oembed
// https://www.tiktok.com/oembed?url=https://www.tiktok.com/@heisty710/video/7632283532965989654
export class TiktokPostOembed extends Schema.Class<TiktokPostOembed>(
  'TiktokPostOembed',
)({
  html: Schema.String,
}) {
  static decode = Schema.decodeUnknownOption(TiktokPostOembed)

  get citeUrl(): string | undefined {
    const template = document.createElement('template')
    template.innerHTML = this.html

    return (
      template.content.querySelector('blockquote')?.getAttribute('cite') ??
      undefined
    )
  }
}
